"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>PanelGroupController
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const radio_group_namespaceObject = require("@base-ui-components/react/radio-group");
const checkbox_group_namespaceObject = require("@base-ui-components/react/checkbox-group");
const external_ActionPanel_variants_cjs_namespaceObject = require("../ActionPanel.variants.cjs");
const external_types_cjs_namespaceObject = require("../types.cjs");
const index_cjs_namespaceObject = require("../../../utils/index.cjs");
function PanelGroupController(props) {
    const { children, type, disabled = false, name, value, defaultValue, onValueChange, slots = {
        baseSlot: ''
    } } = props;
    const { baseSlot } = (0, external_ActionPanel_variants_cjs_namespaceObject.ActionPanelGroupVariants)({});
    const baseSlotClasses = (0, index_cjs_namespaceObject.cn)(baseSlot(), slots.baseSlot);
    const baseGroupProps = {
        className: baseSlotClasses,
        ['aria-labelledby']: name,
        name,
        disabled
    };
    let sanitizedValue;
    let sanitizedDefaultValue;
    function handleOnRadioValueChange(value) {
        if (!onValueChange) return;
        onValueChange(value);
    }
    function handleOnCheckboxValueChange(value) {
        if (!onValueChange) return;
        const valuePrefix = `${name}-`;
        const sanitizedValue = value.map((v)=>v.substring(valuePrefix.length));
        onValueChange(sanitizedValue);
    }
    if (external_types_cjs_namespaceObject.ValidActionPanelGroupSingleTypeValues.includes(type)) {
        sanitizedValue = value ?? `${name}-${value}`;
        sanitizedDefaultValue = defaultValue ?? `${name}-${defaultValue}`;
    }
    if (external_types_cjs_namespaceObject.ValidActionPanelGroupSingleTypeValues.includes(type)) {
        const groupProps = {
            ...baseGroupProps,
            defaultValue: sanitizedDefaultValue,
            value: sanitizedValue,
            onValueChange: handleOnRadioValueChange
        };
        return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(radio_group_namespaceObject.RadioGroup, {
            ...groupProps,
            children: children
        });
    }
    if (external_types_cjs_namespaceObject.ValidActionPanelGroupMultiTypeValues.includes(type)) {
        const groupProps = {
            ...baseGroupProps,
            defaultValue: sanitizedDefaultValue ?? [],
            value: sanitizedValue,
            onValueChange: handleOnCheckboxValueChange
        };
        return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(checkbox_group_namespaceObject.CheckboxGroup, {
            ...groupProps,
            children: children
        });
    }
    return children;
}
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
